export enum TimeSheetType {
    Holiday = 0,
    Sick = 1,
    Working = 2
}